__turbopack_context__.v({
  "filters": "GenresFilter-module__fohO7q__filters",
  "title": "GenresFilter-module__fohO7q__title",
});
